import { render } from "./overview_summary.html?vue&type=template&id=c84a125e&external"
import script from "./overview_summary.js?vue&type=script&lang=js&external"
export * from "./overview_summary.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__